<template>
    <b-card
        header-tag="h4"
        :header="uLang('app.available_reports')"
        class="action-documents-table bg-default-card"
    >
        <generated-reports-table></generated-reports-table>
    </b-card>
</template>
<script>
    import { GeneratedReportsTable } from "~/components/tables";

    export default {
        name: 'GeneratedReports',

        components: {
            GeneratedReportsTable,
        },

        props: {
            loading: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {}
        },
    }
</script>
<style lang="scss">
    table.action-documents-table {
        tr:first-child {
            td, th {
                text-align: left;
                border-top: none;
            }
        }
        td, th {
            padding-left: 0px !important;
        }

    }
    .action_icon {
        color: #5A4587 !important;
    }
    .action_icon:hover {
        color: lighten(#5A4587, 25%) !important;
    }

    .card-block {
        position: relative;
        min-height: 75px;
    }
</style>
